import React from "react";
import icon1 from "../img/svg/medical.svg";
// import icon2 from "../img/svg/clipboards.svg";
// import icon3 from "../img/svg/asset-11.svg";
import customer from "../img/svg/001-hospital bed.svg";
import product from "../img/svg/asset-10.svg";
import award from "../img/svg/020-heart.svg";
import client from "../img/svg/asset-9.svg";
const BlogCard = ({ blogData }) => {
  return (
    <>
      <section className="blog-container">
        <div className="blog-top">
          <div className="blog-top-content">
            <h2 className="blog-top-h2">
              Prasent tempor dictum tell us ut molestie
            </h2>
            <a className="blog-top-a">
              Get A Quote
              <i class="fa-solid fa-arrow-right blog-arrow-right"></i>
            </a>
          </div>
          <div className="blog-cards">
            {blogData.map((curElem) => {
              return (
                <>
                  <div className="blog-top-card" key={curElem.id}>
                    <div className="sec-2-sub-child-2-a">
                      <img src={icon1} alt="" />
                      <div>
                        <h2 className="blog-top-h2-b" id="abc">
                          {curElem.name}
                        </h2>
                        <p className="blog-top-p1">{curElem.description}</p>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
        <div className="blog-counter">
          <div className="blog-customer">
            <img src={customer} alt="" className="counter-img"/>
            <h2>3500</h2>
            <p>Happy Customers</p>
          </div>
          <div className="blog-product">
            <img src={product} alt="" className="counter-img"/>
            <h2>541+</h2>
            <p>Projects Done</p>
          </div>
          <div className="blog-award">
            <img src={award} alt="" className="counter-img"/>
            <h2>40+</h2>
            <p>Awards Win</p>
          </div>
          <div className="blog-client">
            <img src={client} alt="" className="counter-img"/>
            <h2>678</h2>
            <p>Client Works</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogCard;
